import React, { createContext, useContext, useState, useCallback } from 'react';
import { useAuth } from './AuthContext';

const CartContext = createContext(null);

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) throw new Error('useCart must be used within CartProvider');
  return context;
};

export const CartProvider = ({ children }) => {
  const { api, token } = useAuth();
  const [cart, setCart] = useState({ items: [], total_aoa: 0 });
  const [cartCount, setCartCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchCart = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const res = await api().get('/cart');
      setCart(res.data);
      setCartCount(res.data.items.reduce((sum, item) => sum + item.quantity, 0));
    } catch (err) {
      console.error('Error fetching cart:', err);
    }
    setLoading(false);
  }, [api, token]);

  const addToCart = async (productId, quantity = 1) => {
    try {
      const res = await api().post('/cart/add', { product_id: productId, quantity });
      setCartCount(res.data.cart_count);
      await fetchCart();
      return res.data;
    } catch (err) {
      throw err;
    }
  };

  const updateCartItem = async (productId, quantity) => {
    try {
      await api().post('/cart/update', { product_id: productId, quantity });
      await fetchCart();
    } catch (err) {
      throw err;
    }
  };

  const clearCart = async () => {
    try {
      await api().delete('/cart/clear');
      setCart({ items: [], total_aoa: 0 });
      setCartCount(0);
    } catch (err) {
      throw err;
    }
  };

  return (
    <CartContext.Provider value={{ cart, cartCount, loading, fetchCart, addToCart, updateCartItem, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};
